import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock, Sparkles } from 'lucide-react';
const promises = [{
  icon: Clock,
  label: 'We Show Up',
  detail: 'On time, when we say we will.'
}, {
  icon: ShieldCheck,
  label: 'We Work Hard',
  detail: 'Every job, start to finish.'
}, {
  icon: Sparkles,
  label: 'We Leave It Clear',
  detail: 'Swept and ready to use again.'
}];
export function Guarantee() {
  return <section className="relative py-20 lg:py-28 bg-[#C8102E] text-white overflow-hidden" data-id="element-317" data-mp="19fac8poeqdw0">
      <div className="absolute inset-0 bg-grid-faint opacity-[0.06] pointer-events-none" data-id="element-318" data-mp="14gz7uugvsvl6" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-black opacity-10 blur-[140px] rounded-full pointer-events-none" data-id="element-319" data-mp="1j5c47sjvsgg7" />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-320" data-mp="qo9h6cqer2hq">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.55,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-321" data-mp="qlwq9a2o9hsj">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 border border-white/25 backdrop-blur-sm mb-8" data-id="element-322" data-mp="tycrqk6kzft0">
            <ShieldCheck size={16} data-id="element-323" data-mp="yqmfpuo4y5sn" />
            <span className="text-[11px] font-bold tracking-[0.25em] uppercase" data-id="element-324" data-mp="yrp4nx1wdy5x">
              Our Guarantee
            </span>
          </span>

          <h2 className="text-4xl md:text-6xl font-bold leading-[1.05] mb-12" data-id="element-325" data-mp="61p7kkdn1pdm">
            WE SHOW UP. WE WORK HARD.
            <br data-id="element-326" data-mp="b0a7sjsw4922" />
            WE LEAVE YOUR SPACE
            <br data-id="element-327" data-mp="f1lpm35ivpzp" />
            COMPLETELY CLEAR.
          </h2>

          <div className="grid sm:grid-cols-3 gap-4 mb-12 text-left" data-id="element-328" data-mp="f00uocfaq51b">
            {promises.map((promise, i) => {
            const Icon = promise.icon;
            return <motion.div key={promise.label} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1 + i * 0.08
            }} className="bg-white/10 border border-white/20 backdrop-blur-sm rounded-2xl p-6" data-id="element-329" data-mp="1qfpjzag0vg5a" data-mpi={i}>
                  <Icon size={24} className="mb-4" data-id="element-330" data-mp="5ah0jmzjl2j8" />
                  <h3 className="font-bold text-lg mb-1" data-id="element-331" data-mp="cfi949xx78t">{promise.label}</h3>
                  <p className="text-sm text-red-100" data-id="element-332" data-mp="d8irnib30ii">{promise.detail}</p>
                </motion.div>;
          })}
          </div>

          <div className="inline-block bg-[#0E0E0E] rounded-2xl px-8 py-7" data-id="element-333" data-mp="33tnv19pt9gwo">
            <p className="font-oswald text-2xl md:text-3xl text-white leading-tight mb-2" data-id="element-334" data-mp="3ii1z1nyyrbet">
              NOT HAPPY? <span className="text-[#C8102E]" data-id="element-335" data-mp="3drbprznf2oeu">WE MAKE IT RIGHT.</span>
            </p>
            <p className="text-gray-400 text-sm font-medium" data-id="element-336" data-mp="3dpiici4zc05s">
              No runaround. No excuses. Just results.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}